<template>
    <v-container fluid>   
      <LeftMenu/>     
        <v-layout row wrap>   
          <v-flex xs1></v-flex>
          <v-flex xs10>
            <v-data-table
              :headers="headers"
              :items="modelsComputed"
              :items-per-page="50"
              item-key="id"
              sort-by="priceModel"
              class="elevation-1"
              :search="search"
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Price Models</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">New Price Model</v-btn>
                      <v-flex xs12 sm6 md2>
                        <v-switch color="red" v-model="showPassive" class="mx-2" label="Show Passive"></v-switch>  
                      </v-flex>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md10>
                              <v-text-field v-model="editedItem.modelName" label="Price Model"></v-text-field>
                            </v-flex> 
                            <v-flex xs12 sm6 md2>
                              <v-switch color="green" v-model="editedItem.active" class="mx-2" label="Active"></v-switch>  
                            </v-flex>                           
                            <v-flex xs12 sm6 md6>
                              <v-combobox
                                :items="products"
                                label="Select Product"
                                v-model="editedItem.product"
                                item-text="model"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex>    
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.unitValue" :label="unitText"></v-text-field>
                            </v-flex>                           
                            <v-flex xs12 sm6 md6>
                              <v-currency-field :key="editedItem.id" v-model="editedItem.amount" label="Amount"></v-currency-field>
                            </v-flex>                               
                            <v-flex xs12 sm6 md6>
                              <v-combobox
                                :items="currencyListWithText"
                                label="Select Currency"
                                v-model="editedItem.currency"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex>                                                                                                                                                                                                                           
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
              </template> 
              <template v-slot:body.append>                    
              </template>             
              <template v-slot:item.action="{ item }">              
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
const API_URL = 'definitions/priceModels';
const CURRENCIES_API_URL = 'definitions/currencies';
const PRODUCTS_API_URL = 'definitions/products';
export default {
    components:{
      LeftMenu
    },
    data () {
    return {
      dialog: false,
      search: '',
      showPassive : false,
      products:[],
      currencyList:[],
      priceModels: [
        {     
          modelName: '',
          product: '',
          amount: '',       
          currency: '',  
        },               
      ],
      editedIndex: -1,
      editedItem: {
        modelName: '',
        product: '',
        amount: 0,   
        currency: '', 
      },
      defaultItem: {
        modelName: '',
        product: '',
        amount: 0,       
        currency: '', 
      }      
    }
  },
  computed: {
    headers () {
      return [
        {
          text: 'Price Model',
          align: 'left',
          sortable: true,
          value: 'modelName',
        },
        { text: 'Product',  value: 'product.model'  },   
        { text: 'Unit Value',  value: 'unitAndValue'  },         
        { text: 'Amount',  value: 'amount'  },                    
        { text: 'Currency',  value: 'currency.code'  },  
        { text: 'Status',  value: 'status'  },  
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    modelsComputed(){
      return this.priceModels.map((item) => {
        item.unitAndValue = item.unitValue + ' - ' + ( item.product.unit ? item.product.unit.text : '');
        item.status = item.active ? 'Active' : 'Passive';
        return item;  
      })
    },
    currencyListWithText(){
      return this.currencyList.map((item) => {
        return {
          id: item.id,
          code: item.code,
          text: item.code+' - '+item.text          
        };
      })
    },
    unitText(){
      if (this.editedItem && this.editedItem.product&& this.editedItem.product.unit)
        return this.editedItem.product.unit.text;
      else 
      return '';
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Price Model' : 'Edit Price Model'
    },
  },
  created() {    
    this.getPriceModels(this.showPassive); 
    this.getCurrencies();
    this.getProducts();   
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    showPassive(showPassive){     
      this.getPriceModels(showPassive);
    },
  },
  methods: {
    editItem (item) {
      this.editedIndex = this.priceModels.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.priceModels.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.deletePriceModel(item);
      } 
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {        
        this.updatePriceModel(this.editedItem);
      } else {
        this.addPriceModel(this.editedItem);         
      }      
    },
    addPriceModel(item){
      this.$axios.post(this.$apiurl + API_URL, {
        modelName: item.modelName,
        amount: item.amount,
        unitValue: item.unitValue,
        currency: item.currency.id,
        productId: item.product.id,
        active: item.active ? 1 : 0
      })
      .then(response => {        
        if (response.status === 201) {
          this.priceModels.push(this.editedItem);
          this.getPriceModels(this.showPassive); 
          this.close();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updatePriceModel(item){
      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        modelName: item.modelName,
        unitValue: item.unitValue,
        amount: item.amount,
        currency: item.currency.id,
        productId: item.product.id,
        active: item.active ? 1 : 0
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.priceModels[this.editedIndex], this.editedItem);
          this.getPriceModels(this.showPassive); 
          this.close();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    deletePriceModel(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
        this.priceModels.splice(index, 1);
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getPriceModels(showPassive){
      var url = this.$apiurl + API_URL;
      if(showPassive){
        url += '/status/'+false;
      }else{
         url += '/status/'+true;
      }     
      this.$axios.get(url)
          .then(response => {
              this.priceModels = response.data
          }) 
          .catch(error => {
              console.log(error);
          });                         
    },
    getProducts(){     
        this.$axios.get(this.$apiurl + PRODUCTS_API_URL)
            .then(response => {
                this.products = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },   
    getCurrencies(){     
        this.$axios.get(this.$apiurl + CURRENCIES_API_URL)
            .then(response => {
                this.currencyList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },   
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
